import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout/Layout";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import MissionBriefing from "./pages/MissionBriefing";
import LoginPage from "./pages/LoginPage";
import OperationalReadout from "./pages/OperationalReadout";
import OperatorProfile from "./pages/OperatorProfile";
import RegisterPage from "./pages/RegisterPage";
import SponsorsPage from "./pages/SponsorsPage";
import "./App.css";

function App() {
  return (
    <Router>
      <div className="App">
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/mission-briefing" element={<MissionBriefing />} />
            <Route path="/login" element={<LoginPage />} />
            <Route
              path="/operational-readout"
              element={<OperationalReadout />}
            />
            <Route path="/operator-profile" element={<OperatorProfile />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/sponsors" element={<SponsorsPage />} />
          </Routes>
        </Layout>
      </div>
    </Router>
  );
}

export default App;
